import { useState } from 'react'
import { Button } from 'components/ui/Button/Button'
import { NavItem } from 'components/ui/NavItem/NavItem'
import { MetricCard } from 'components/ui/MetricCard/MetricCard'
import { Card } from 'components/ui/Card/Card'
import { StatusPill } from 'components/ui/StatusPill/StatusPill'
import { GlassPanel } from 'components/ui/GlassPanel/GlassPanel'
import { Field } from 'components/ui/Field/Field'
import { tokens } from 'styling/tokens'
import {
  PreviewBackground,
  PreviewRow,
  PreviewHeaderActions,
  PreviewSidebar,
  PreviewBody,
  PreviewMain,
  PreviewMetrics,
  PreviewTitle,
  PreviewStaffRow,
  PreviewStaffName,
  PreviewPillRow,
  PreviewFields,
} from './DesignSystemPreview.styled'

const NAV_ITEMS = ['Employees', 'Attendance', 'Tasks', 'Transport', 'Reports']

const DesignSystemPreview = () => {
  const [active, setActive] = useState('Employees')

  return (
    <PreviewBackground>
      <PreviewRow>
        <GlassPanel>Search staff, sites…</GlassPanel>
        <PreviewHeaderActions>
          <Button variant='primary'>Add employee</Button>
        </PreviewHeaderActions>
      </PreviewRow>

      <PreviewBody>
        <PreviewSidebar>
          {NAV_ITEMS.map((label) => (
            <NavItem
              key={label}
              label={label}
              active={active === label}
              onSelect={() => setActive(label)}
            />
          ))}
        </PreviewSidebar>

        <PreviewMain>
          <PreviewTitle>Employees</PreviewTitle>

          <PreviewMetrics>
            <MetricCard
              label='Total employees'
              value='248'
              trailing={<StatusPill status='success'>+4</StatusPill>}
            />
            <MetricCard
              label='Productivity'
              value='94%'
              sublabel='vs last week'
              trend={{ value: '2.4%', positive: true }}
              accentColor={tokens.status.success.fg}
            />
            <MetricCard
              label='Overtime'
              value='5.1%'
              sublabel='vs last week'
              trend={{ value: '0.8%', positive: false }}
              accentColor={tokens.status.danger.fg}
            />
          </PreviewMetrics>

          <Card>
            <PreviewStaffRow>
              <PreviewStaffName>Ana Petrović — Supervisor</PreviewStaffName>
              <StatusPill status='success' dot>
                Active
              </StatusPill>
            </PreviewStaffRow>
            <PreviewPillRow>
              <StatusPill status='success' dot>
                Present
              </StatusPill>
              <StatusPill status='warning' dot>
                On leave
              </StatusPill>
              <StatusPill status='danger' dot>
                Absent
              </StatusPill>
              <StatusPill status='info' dot>
                New
              </StatusPill>
              <StatusPill status='neutral' dot>
                Draft
              </StatusPill>
              <StatusPill status='accent' dot>
                Featured
              </StatusPill>
            </PreviewPillRow>
          </Card>

          <Card glow>
            <PreviewTitle>Form fields</PreviewTitle>
            <PreviewFields>
              <Field id='note' label='Full name' placeholder='Type here' />
              <Field id='pwd' label='Password' type='password' placeholder='••••••••' />
              <Field
                id='email'
                label='Email'
                defaultValue='not-an-email'
                error='Enter a valid email address'
              />
              <Field id='phone' label='Phone' placeholder='+233…' hint='Include the country code' />
            </PreviewFields>
          </Card>
        </PreviewMain>
      </PreviewBody>
    </PreviewBackground>
  )
}

export default DesignSystemPreview
